import React from 'react';

import { OverlayConfirmation } from '../shared/OverlayConfirmation';

type AutoplayDisallowedOverlayProps = {
  onStartPlayingClick: () => void;
  onCancel: () => void;
};

export const AutoplayDisallowedOverlay = (props: AutoplayDisallowedOverlayProps) => {
  return (
    <OverlayConfirmation
      header={'Audio could not start playing automatically'}
      text={'Do you want to start the audio?'}
      buttonLabel={'Play audio'}
      onClick={props.onStartPlayingClick}
      onCancel={props.onCancel}
    />
  );
};
